export var CollectionItemType;
(function (CollectionItemType) {
    CollectionItemType["Content"] = "Content";
    CollectionItemType["Collection"] = "Collection";
    CollectionItemType["Carousel"] = "Carousel";
})(CollectionItemType || (CollectionItemType = {}));
//# sourceMappingURL=CollectionItemType.js.map